export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7869.4a52b9dd.jpg";